import _axios from '../util/axios/AxiosConfig'

export function getSubWoDetail(params){
  return _axios({
    url: '/api/MES/wo/getSubWoDetail',
    method: 'get',
    params:params
  })
}

//getUserWoAssTask
export function getUserWoAssTask(params){
  return _axios({
    url: '/api/MES/wo/getUserWoAssTask',
    method: 'get',
    params:params
  })
}

export function getUserSubWos(params){
  return _axios({
    url: '/api/MES/wo/getUserSubWos',
    method: 'get',
    params:params
  })
}


export function getBatchProductDetail(params){
  return _axios({
    url: '/api/MES/wo/getBatchProductDetail',
    method: 'get',
    params:params
  })
}

export function startWo(woId){
  
  return _axios({
    url: `/api/MES/wo/startWo?woId=${woId}`,
    method: 'post'
  })
}


export function doNotLastWork(data){
  return _axios({
    url: '/api/MES/wo/doNotLastWork',
    method: 'post',
    data:data
  })
}

export function doLastWork(data){
  return _axios({
    url: '/api/MES/wo/doLastWork',
    method: 'post',
    data:data
  })
}

export function redo(transfOrderId,workmanshipName){
  return _axios({
    url: `/api/MES/wo/redo?transfOrderId=${transfOrderId}&workmanshipName=${workmanshipName}`,
    method: 'post'
  })
}

//getProductsAttachList
export function getProductsAttachList(productId){
  return _axios({
    url: `/api/WMS/MerchSales/getProductsAttachList?productId=${productId}`,
    method: 'get'
  })
}

//downloadAttach
export function getProductAttach(key1,key2,key3,key4){
  return _axios({
    url: `/api/WMS/MerchSales/getProductAttach?key1=${key1}&&key2=${key2}&&key3=${key3}&&key4=${key4}`,
    method: 'get'
  })
}

export function auditReport(transfOrderId){
  return _axios({
    url: `/api/MES/wo/auditTransfOrder?transfOrderId=${transfOrderId}`,
    method: 'get'
  })
}

export function finishReportCheck(woId,transfOrderId,failedCount,description){
  return _axios({
    url: `/api/MES/wo/finishReportCheck?woId=${woId}&transfOrderId=${transfOrderId}&failedCount=${failedCount}&description=${description}`,
    method: 'post'
  })
}

export function uploadCheckImages(transfOrderId,images,isLastWork){
  return _axios({
    url: `/api/MES/Wo/uploadCheckImagesByBase64?transferId=${transfOrderId}&isLastWork=${isLastWork}`,
    method: 'post',
    data:images
  })
}